import React from 'react';
import { formSubmitHandler } from 'components/Crud';
import { Form, FormValues } from 'components/Forms';
import { AppThunk } from 'store';
import JobType from 'models/JobTypes';
import { FormRefProp } from 'components/Modal';
import {
  buildInitialFormFields,
  initialFormValidation
} from './InitialFormConfig';

interface InitialFormProps extends FormRefProp {
  jobTypeData: JobType[];
  initialValues?: {
    postcode: string;
    jobType: string;
  };
  availabilityApiCallback: (data: FormValues) => AppThunk;
  setFormStepSuccess: (success: boolean) => void;
  setIsFormStepSubmitting: (isSubmitting: boolean) => void;
}

export default function InitialForm({
  jobTypeData,
  initialValues,
  availabilityApiCallback,
  setFormStepSuccess,
  setIsFormStepSubmitting,
  formRef
}: InitialFormProps) {
  const processAddJobFormFields = (values: FormValues) => values;
  return (
    <Form
      validationFunc={initialFormValidation}
      fields={buildInitialFormFields(jobTypeData)}
      initialValues={initialValues}
      onSubmit={formSubmitHandler(
        availabilityApiCallback,
        processAddJobFormFields
      )}
      goBackToPreviousPage={false}
    >
      {({ form, submitting, submitSucceeded, submitErrors }) => {
        setFormStepSuccess(!submitErrors && submitSucceeded);
        setIsFormStepSubmitting(submitting);

        // eslint-disable-next-line no-param-reassign
        formRef.current = form;
      }}
    </Form>
  );
}
